<template>
  <div class="infinite" ref="container">
    <slot></slot>
  </div>
</template>

<script>
  import _ from 'lodash'
  import queryString from 'query-string'

  // Start the next-batch fetch this many pixels before the container bottom
  // reaches the viewport bottom, so the user rarely sees an empty tail.
  const PREFETCH_MARGIN_PX = 600;

  export default {
    data() {
      return {
        isMore: true,
        checkState: true,
        isEmpty: false
      }
    },
    props: [
      'endpoint'
    ],
    computed: {
      page() {
        return this.$store.getters.getPropertiesPage
      }
    },
    methods: {
      loadMoreProperties() {
        if (this.checkState === false) return;
        this.checkState = false;
        if (!this.isMore) {
          return
        }

        if (!this.isEmpty) {
          $('.infinite').addClass('infinite__elements-loading');
        }

        window.axios.get('/api/' + this.endpoint + '?list=1&' + queryString.stringify(_.assign(
          queryString.parse(window.location.search),
          { page: this.page }
        ))).then((response) => {
          this.checkState = true;
          if (response.data.data.length) {

            this.$store.commit('INCREASE_PROPERTIES_PAGE')
            this.$store.commit('PUSH_TO_PROPERTIES_COLLECTION', response.data.data)
          } else {
            this.isMore = false;
            $('.infinite').removeClass('infinite__elements-loading');
          }

          if (response.data.to == response.data.total) this.isEmpty = true;
        }).finally(() => {
            $('.infinite').removeClass('infinite__elements-loading');
        });
      }
    },
    mounted() {
      const throttled = _.throttle(() => {
        const rect = this.$refs.container.getBoundingClientRect();
        if (rect.bottom < window.innerHeight + PREFETCH_MARGIN_PX) {
          this.loadMoreProperties()
        }
      }, 500);
      window.addEventListener('scroll', throttled, { passive: true });

      // Photo save-deterrence for lazily appended cards is handled globally by
      // modules/property-photo-protection.js (delegated on .js-protected-property-photo),
      // so InfiniteScroll no longer binds its own contextmenu listener.
    }
  }
</script>
